module.exports = __webpack_public_path__ + "img/map 4 (1) 1@3x.f515ccf7.png";